<script setup lang="ts"></script>

<template>
  <hr data-testid="newAirRoadSeparator" :class="$style.newAirRoadSeparator" />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSeparator {
  background-color: colors.$color-text-tertiary;
  height: 1px;
  line-height: 0;
  border: 0;
}
</style>
